import React from 'react';


class Index extends React.Component {


    render() {
        let { address } = this.props;
        return (
            <div style={{
                padding: 10
            }}>
                <p style={{
                    fontWeight: 600,
                    marginBottom: 5
                }}>{this.props.title}</p>

                <p>
                    {address.name ? address.name : '-'}
                </p>
                <p>
                    {address.address ? address.address : '-'}
                </p>
                <p>
                    {address.city ? address.city : '-'}
                </p>
               


            </div>
        )
    }
}

Index.defaultProps = {
    title:"Shipping to"
}

export default Index;